import Mixitup from 'mixitup';

const combineArrays = ([head, ... [headTail, ... tailTail]]) => {
    if(!headTail) return head;

    const combined = headTail.reduce((acc, x) => {
        return acc.concat(head.map(h => `${h}${x}`))
    }, []);

    return combineArrays([combined, ... tailTail]);
}

if(document.querySelector('.filter-container')) {
    const extractProductFiltersFromUrl = () => {
        let filters = '.' + location.search.replace(/^\?filters=/, '').replace(/,/g, '.');

        if(filters === '.') {
            filters = '.filter-item';
        }

        document.querySelectorAll('.filter-input').forEach((filterItem) => {
            filterItem.checked = false;
        });

        filters.split('.').forEach((filterItem) => {
            if(filterItem !== '') {
                filterItem = '.' + filterItem;
                if(document.querySelector('.filter-input[data-toggle="' + filterItem + '"]')) {
                    document.querySelector('.filter-input[data-toggle="' + filterItem + '"]').checked = true;
                }
            }
        });

        setTimeout(() => {
            setCounters();
        }, 250);

        return getFilterString();
    }

    const setCounters = () => {
        document.querySelectorAll('.filter-input').forEach((element) => {
            const filterString = getFilterString({
                name:   element.name,
                values: [element.dataset.toggle]
            });

            const elements = Array.from(document.querySelectorAll(filterString));
            if(elements.length === 0) {
                if(element.parentNode.querySelector('.count')) {
                    element.parentNode.style.opacity                     = '0.3';
                    element.parentNode.querySelector('.count').innerHTML = '(' + elements.length + ')';
                }
            } else {
                if(element.parentNode.querySelector('.count')) {
                    element.parentNode.style.opacity                     = '1';
                    element.parentNode.querySelector('.count').innerHTML = '(' + elements.length + ')';
                }
            }
        });

        if(document.querySelector('.products-count')) {
            document.querySelector('.products-count').innerHTML = '(' + Array.from(document.querySelectorAll('.filter-item')).filter((s) =>
                window.getComputedStyle(s).getPropertyValue('display') !== 'none'
            ).length + '/' + document.querySelectorAll('.filter-item').length + ')';
        }

        // Put choices behind the dropdown-menu element on product variation filter.
        if(document.querySelector('button#size .choices')) {
            const values = Array.from(document.querySelectorAll('[name="size"]:checked')).map((el) => el.value).join(', ');

            document.querySelector('button#size .choices').innerHTML = values !== '' ? '(' + values + ')' : '';
        }
    }

    const getFilterString = (appendObject) => {
        let ands = [];
        let ors  = [];
        let result;
        document.querySelectorAll('.filter-items input:checked').forEach((element) => {
            if(element.dataset['action'] === 'or') {
                ors.push(element.dataset.toggle);
            } else if(element.dataset['action'] === 'and') {
                result = ands.find(item => item.name === element.name);
                if(typeof result === 'undefined') {
                    ands.push({
                        name:   element.name,
                        values: [element.dataset.toggle]
                    });
                } else {
                    result.values.push(element.dataset.toggle);
                }
            }
        });

        if(appendObject) {
            result = ands.find(item => item.name === appendObject.name);
            if(typeof result === 'undefined') {
                ands.push(appendObject)
            } else {
                result.values = appendObject.values;
            }
        }

        let toCombine = [];
        for(let i in ands) {
            toCombine.push(ands[i].values);
        }

        if(ors.length > 0) {
            toCombine.push(ors);
        }

        if(toCombine.length > 0) {
            ors = combineArrays(toCombine);
        }

        let filterString = '';
        if(ors.length === 0 && ands.length > 0) {
            filterString = ands.join('');
        } else {
            filterString = ors.join(', ');
        }

        return filterString === '' ? '.filter-item' : filterString;
    }

    const containerEl = document.querySelector('.filter-container');
    const mixer       = Mixitup(containerEl, {
        selectors: {
            target:  '.filter-item',
            control: '.filter-input'
        },
        controls:  {
            enable:      false,
            toggleLogic: 'and'
        },
        animation: {
            duration: 300,
            easing:   'cubic-bezier(0.645, 0.045, 0.355, 1)'
        },
        load:      {
            filter: extractProductFiltersFromUrl()
        },
        callbacks: {
            onMixEnd: function(state) {
                let filterValues = [];

                document.querySelectorAll('.filter-items input:checked').forEach((element) => {
                    if(element.dataset.toggle) {
                        filterValues.push(element.dataset.toggle.replace(/^\./, ''));
                    }
                });
                if(filterValues.length > 0) {
                    const queryString = '?filters=' + filterValues.join(',');
                    history.pushState(null, document.title, window.location.pathname + queryString);
                } else {
                    history.pushState(null, document.title, window.location.pathname);
                }

                setCounters();
            }
        }
    });

    window.addEventListener('popstate', (event) => {
        let filters = extractProductFiltersFromUrl();
        if(mixer.getState().activeFilter.selector === filters) return;
        mixer.filter(filters);
    });

    document.querySelectorAll('.filter-input').forEach((element) => {
        let elements = document.querySelectorAll(element.dataset.toggle);
        if(element.parentNode.querySelector('.count')) {
            if(elements.length === 0) {
                element.parentNode.classList.add('d-none');
            } else {
                element.parentNode.querySelector('.count').innerHTML = '(' + elements.length + ')';
            }
        }
    });

    document.querySelectorAll('.filter-items input').forEach((element) => {
        element.addEventListener('change', (e) => {
            e.preventDefault();

            updateProductFilter();
        });
    });

    const updateProductFilter = () => {
        mixer.filter(getFilterString());
    }
}